import axios from "axios";

const REACT_APP_BASE_ROUTE_DOTNET_SERVER =
  process.env.REACT_APP_BASE_ROUTE_DOTNET_SERVER;
const REACT_APP_BASE_ROUTE_WHATSAPP_SERVER =
  process.env.REACT_APP_BASE_ROUTE_WHATSAPP_SERVER;

export const askInternAi = async (prompt, accessToken) => {
  try {
    const response = await fetch(
      `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}internai/ask`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${accessToken}`,
        },
        body: JSON.stringify({ prompt }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Erro ao comunicar com a IA Interna:", error);
    return {
      answer:
        "Desculpe, não consegui processar sua pergunta. Verifique sua conexão e tente novamente.",
    };
  }
};

export async function obterMedia(mediaId, agentNumber) {
  try {
    const res = await axios.get(
      `${REACT_APP_BASE_ROUTE_WHATSAPP_SERVER}media/${mediaId}/${agentNumber}`,
      {
        responseType: "blob",
      }
    );
    return URL.createObjectURL(res.data);
  } catch (error) {
    console.error("Erro ao buscar mídia:", error);
    return null;
  }
}

export async function obterChats(agentNumber, token) {
  const res = await axios.get(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}chat?agentNumber=${agentNumber}`,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function obterShots(token) {
  const res = await axios.get(`${REACT_APP_BASE_ROUTE_DOTNET_SERVER}shot/dto`, {
    headers: { Authorization: token },
  });
  return res.data;
}

export async function obterInformacoesDisparos(token, month, year) {
  const res = await axios.get(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}shot/monthly-stats?month=${month}&year=${year}`,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function obterVendas(token) {
  const res = await axios.get(`${REACT_APP_BASE_ROUTE_DOTNET_SERVER}sale/dto`, {
    headers: { Authorization: token },
  });
  return res.data;
}

export async function searchVendas(
  searchTerm,
  pageNumber,
  pageSize,
  token,
  order = "desc",
  startDate = null,
  endDate = null,
  status = null
) {
  let url = `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}sale/search?searchTerm=${encodeURIComponent(
    searchTerm || ""
  )}&pageNumber=${pageNumber}&pageSize=${pageSize}&order=${order}`;

  if (startDate) {
    url += `&startDate=${encodeURIComponent(startDate)}`;
  }
  if (endDate) {
    url += `&endDate=${encodeURIComponent(endDate)}`;
  }
  if (status) {
    url += `&status=${status}`;
  }

  const res = await axios.get(url, {
    headers: { Authorization: token },
  });
  return res.data;
}

export async function searchShots(
  searchTerm,
  pageNumber,
  pageSize,
  token,
  order = "desc",
  startDate = null,
  endDate = null,
  status = null
) {
  let url = `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}shot/search?searchTerm=${encodeURIComponent(
    searchTerm || ""
  )}&pageNumber=${pageNumber}&pageSize=${pageSize}&order=${order}`;

  if (startDate) {
    url += `&startDate=${encodeURIComponent(startDate)}`;
  }
  if (endDate) {
    url += `&endDate=${encodeURIComponent(endDate)}`;
  }
  if (status) {
    url += `&status=${status}`;
  }

  const res = await axios.get(url, {
    headers: { Authorization: token },
  });
  return res.data;
}

export async function criarShot(token, shot) {
  const res = await axios.post(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}shot`,
    shot,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function criarShot2(token, shot) {
  const res = await axios.post(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}shot`,
    shot,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function obterModelos(token) {
  const res = await axios.get(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}MessageModel`,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function enviarDisparo(token, agentNumber, shotId, clients) {
  const res = await axios.post(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}shot/send/${shotId}?agentNumber=${agentNumber}`,
    clients,
    {
      headers: { Authorization: token },
    }
  );

  return res.status;
}

export async function verificarModelo(token, shotId) {
  const res = await axios.post(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}shot/check-template-status/${shotId}`,
    null,
    {
      headers: { Authorization: token },
    }
  );

  return res.data;
}

export async function criarModelo(token, modeloInfo) {
  const res = await axios.post(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}messageModel`,
    modeloInfo,
    {
      headers: { Authorization: token },
    }
  );

  if (res.status == 201) {
    try {
      var shotResponse = await axios.post(
        `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}shot`,
        {
          messageModelId: res.data.id,
          name: modeloInfo.name,
          status: 1,
          header: {
            text: modeloInfo.headerText,
          },
          body: {
            text: modeloInfo.bodyText,
          },
          footer: {
            text: modeloInfo.footerText,
          },
        },
        {
          headers: { Authorization: token },
        }
      );
      return shotResponse.status;
    } catch (error) {
      return null;
    }
  } else {
    return null;
  }
}

export async function iniciarChat(
  to,
  agentNumber,
  message,
  whatsappToken,
  token,
  isFromPlatform
) {
  const res = await axios.post(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}shot/start-chat?agentNumber=${agentNumber}&whatsappToken=${whatsappToken}&isFromPlatform=${isFromPlatform}`,
    { to, message, agent_number: agentNumber, whatsapp_token: whatsappToken },
    {
      headers: { Authorization: token },
    }
  );
  return res.status;
}

export async function iniciarChatLeads(token, agentNumber, client_shot_dto) {
  const res = await axios.post(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}shot/start-chat-leads?agentNumber=${agentNumber}`,
    { client_shot_dto },
    {
      headers: { Authorization: token },
    }
  );
  return res.status;
}

export async function criarProduto(token, product) {
  const res = await axios.post(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}product`,
    product,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function gerarPix(token, identificationType) {
  const res = await axios.post(
    `${process.env.REACT_APP_BASE_ROUTE_DOTNET_SERVER}api/payments/signature-pix`,
    {
      identificationType,
      description: "Pagamento da assinatura.",
    },
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function gerarPixDisparos(token, valor, quantidade) {
  const res = await axios.post(
    `${process.env.REACT_APP_BASE_ROUTE_DOTNET_SERVER}payments/shots-pix`,
    {
      valor,
      quantidade,
      description: `Compra de ${quantidade} disparos avulsos.`,
    },
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function verificarPagamento(token, paymentId) {
  const res = await axios.post(
    `${process.env.REACT_APP_BASE_ROUTE_DOTNET_SERVER}payments/verify/${paymentId}`,
    {
      headers: { Authorization: token },
    }
  );
  return res;
}

export async function verificarPagamentoShotSale(token, paymentId) {
  const res = await axios.post(
    `${process.env.REACT_APP_BASE_ROUTE_DOTNET_SERVER}payments/verify-shotsale/${paymentId}`,
    null,
    {
      headers: { Authorization: token },
    }
  );
  return res;
}

export async function editarProduto(token, product) {
  const res = await axios.put(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}product/${product.id}`,
    product,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function obterCategorias(token) {
  const res = await axios.get(`${REACT_APP_BASE_ROUTE_DOTNET_SERVER}category`, {
    headers: { Authorization: token },
  });
  return res.data;
}

export async function obterAdmins(token) {
  const res = await axios.get(`${REACT_APP_BASE_ROUTE_DOTNET_SERVER}admin`, {
    headers: { Authorization: token },
  });
  return res.data;
}

export async function changePass(actual_pass, new_pass, admin_id, token) {
  const res = await axios.put(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}admin/change-password/${admin_id}`,
    {
      currentPassword: actual_pass,
      newPassword: new_pass,
    },
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function searchChats(
  searchTerm,
  pageNumber,
  pageSize,
  agentNumber,
  token,
  order = "desc",
  startDate = null,
  endDate = null,
  tags = null,
  withMessage = false
) {
  let url = `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}chat/search?agentNumber=${agentNumber}&searchTerm=${encodeURIComponent(
    searchTerm
  )}&pageNumber=${pageNumber}&pageSize=${pageSize}&order=${order}`;

  if (startDate) {
    url += `&startDate=${encodeURIComponent(startDate)}`;
  }
  if (endDate) {
    url += `&endDate=${encodeURIComponent(endDate)}`;
  }
  if (tags) {
    url += `&tagIds=${tags}`;
  }

  if (withMessage) {
    url += `&withMessage=${withMessage}`;
  }

  const res = await axios.get(url, {
    headers: { Authorization: token },
  });
  return res.data;
}

export async function searchProducts(
  searchTerm,
  pageNumber,
  pageSize,
  token,
  order = "desc",
  startDate = null,
  endDate = null,
  categoryIds = null,
  status = null
) {
  let url = `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}product/search?searchTerm=${encodeURIComponent(
    searchTerm
  )}&pageNumber=${pageNumber}&pageSize=${pageSize}&order=${order}`;

  if (startDate) {
    url += `&startDate=${encodeURIComponent(startDate)}`;
  }
  if (endDate) {
    url += `&endDate=${encodeURIComponent(endDate)}`;
  }
  if (categoryIds) {
    url += `&categoryIds=${categoryIds}`;
  }

  if (status) {
    url += `&status=${status}`;
  }

  const res = await axios.get(url, {
    headers: { Authorization: token },
  });
  return res.data;
}

export async function obterChat(token, id) {
  const res = await axios.get(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}chat/${id}`,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function obterMensagens(chatId, agentNumber, token) {
  const res = await axios.get(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}message/chat/${chatId}/${agentNumber}`,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function obterTags(token) {
  const res = await axios.get(`${REACT_APP_BASE_ROUTE_DOTNET_SERVER}tag`, {
    headers: { Authorization: token },
  });
  return res.data;
}

export async function searchTags(searchTerm, token) {
  const res = await axios.get(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}tag/search?name=${searchTerm}`,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function saveChatIdToTag(tagId, chatId, token) {
  const res = await axios.post(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}tag/${tagId}/chats/${chatId}`,
    null,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function saveTagsToTheChat(newTags, chatId, token) {
  const res = await axios.put(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}chat/tag/${chatId}`,
    newTags,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function removeChatIdFromTag(tagId, chatId, token) {
  const res = await axios.delete(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}tag/${tagId}/chats/${chatId}`,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function criarTag(tag, token) {
  const res = await axios.post(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}tag`,
    tag,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function criarCategoria(tag, token) {
  const res = await axios.post(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}category`,
    tag,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function deleteTag(id, token) {
  const res = await axios.delete(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}tag/${id}`,
    {
      headers: { Authorization: token },
    }
  );

  if (res.status === 200) return true;
  else return false;
}

export async function editTag(tag, token) {
  const res = await axios.put(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}tag/${tag.id}`,
    tag,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function editCategory(tag, token) {
  const res = await axios.put(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}category/${tag.id}`,
    tag,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function obterTag(id, token) {
  const res = await axios.get(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}tag/${id}`,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function editarStatusAgente(chatId, newStatus, token) {
  const res = await axios.put(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}chat/status?id=${chatId}&newStatus=${newStatus}`,
    {
      headers: { Authorization: token },
    }
  );
  return res;
}

export async function editarStatusTodosOsAgentes(token) {
  const res = await axios.put(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}chat/status/all?newStatus=2`,
    {},
    {
      headers: { Authorization: token },
    }
  );
  return res;
}

export async function editarStatusVenda(saleId, newStatus, token) {
  const res = await axios.put(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}sale/${saleId}/new-status/${newStatus}`,
    {
      headers: { Authorization: token },
    }
  );
  return res;
}

export async function sendWhatsapp(
  message,
  agentNumber,
  isFromAdmin,
  chatId,
  token
) {
  const res = await axios.post(
    `${REACT_APP_BASE_ROUTE_WHATSAPP_SERVER}send-whatsapp`,
    {
      message,
      isFromAdmin,
      to: chatId,
      whatsappNumId: agentNumber,
    },
    {
      headers: { Authorization: token },
    }
  );

  return res;
}

export async function createMultipleClients(clients, token) {
  const res = await axios.post(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}chat/multiple`,
    clients,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function getPrompt(token, agentNumber) {
  const res = await axios.get(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}agent/prompt?agentNumber=${agentNumber}`,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function updatePrompt(token, newPrompt, agentNumber) {
  const res = await axios.put(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}agent/prompt`,
    {
      NewPrompt: newPrompt,
      AgentNumber: agentNumber,
    },
    {
      headers: { Authorization: token },
    }
  );
  return res.status === 200;
}

export async function getAgents(token) {
  const res = await axios.get(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}agent/all`,
    {
      headers: { Authorization: token },
    }
  );
  return res;
}

export async function obterConfiguracaoRemarketing(token, agentNumber) {
  const res = await axios.get(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}agent/remarketing-config?agentNumber=${agentNumber}`,
    {
      headers: { Authorization: token },
    }
  );
  return res.data;
}

export async function salvarConfiguracaoRemarketing(
  token,
  agentNumber,
  config
) {
  const res = await axios.put(
    `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}agent/remarketing-config?agentNumber=${agentNumber}`,
    config,
    {
      headers: { Authorization: token },
    }
  );
  return res.status;
}

export async function importData(file, dataType, token) {
  const formData = new FormData();
  formData.append("file", file);

  const url = `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}dataextract/${dataType}/import`;

  try {
    const res = await axios.post(url, formData, {
      headers: {
        Authorization: token,
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (error) {
    console.error(`Error importing ${dataType} data:`, error);
    throw error.response?.data || new Error("An error occurred during import.");
  }
}

export async function getPaginatedData(dataType, page, pageSize, token) {
  const url = `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}dataextract/${dataType}?pageNumber=${page}&pageSize=${pageSize}`;
  try {
    const res = await axios.get(url, {
      headers: { Authorization: token },
    });
    return res.data;
  } catch (error) {
    console.error(`Error fetching paginated data for ${dataType}:`, error);
    throw (
      error.response?.data ||
      new Error("An error occurred while fetching data.")
    );
  }
}

export async function exportDataToExcel(dataType, token) {
  const url = `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}dataextract/${dataType}/export`;
  try {
    const res = await axios.get(url, {
      headers: { Authorization: token },
      responseType: "blob",
    });
    return res;
  } catch (error) {
    console.error(`Error exporting ${dataType} data:`, error);
    throw error.response?.data || new Error("An error occurred during export.");
  }
}

export async function obterModeloRemarketing(token, agentNumber) {
  try {
    const res = await axios.get(
      `${REACT_APP_BASE_ROUTE_DOTNET_SERVER}agent/remarketing-model?agentNumber=${agentNumber}`,
      {
        headers: { Authorization: token },
      }
    );
    return res.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    }
    console.error("Erro ao obter modelo de remarketing:", error);
    throw error;
  }
}
